import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BaseColorsTheme,
  MbjAccordion,
  MbjAccordionItem,
  MbjButton,
  MbjFlex,
  MbjLoading,
  MbjNoResult,
  MbjScrollArea,
  MbjSearchBar,
} from "@mbj-front-monorepo/ui";
import { useGetEmployeesCompetences } from "@mbj-front-monorepo/data-access";
import styled from "styled-components";
import { MbjEmployeeLineCompetence } from "./parts/MbjEmployeeLineCompetence";

interface MbjEmployeeActiviteAccordionCtrlProps {
  className?: string;

  themeColor?: BaseColorsTheme;

  employeeId?: number;

  isEditable?: boolean;

  callToAction?: boolean;
}

const MbjEmployeeActiviteAccordionCtrl = (props: MbjEmployeeActiviteAccordionCtrlProps) => {
  const navigate = useNavigate();
  const queryCompetencesEmployee = useGetEmployeesCompetences(props.employeeId);
  const [search, setSearch] = useState<string>();

  const CompFiltered = useMemo(() => {
    if (!queryCompetencesEmployee || !queryCompetencesEmployee.data) return [];
    if (!search || search === "") return queryCompetencesEmployee.data;
    return queryCompetencesEmployee.data.filter((comp) => {
      if (comp.Competence?.libelle?.toLowerCase().includes(search.toLowerCase())) return true;
      if (comp.EmployeeActivites) {
        for (const employeeActivite of comp.EmployeeActivites) {
          if (employeeActivite.Activite?.libelle?.toLowerCase().includes(search.toLowerCase())) return true;
        }
      }
      return false;
    });
  }, [queryCompetencesEmployee.data, search]);

  return (
    <MbjFlex direction={"column"} className={props.className} wrap={"nowrap"} grow={1}>
      {queryCompetencesEmployee.isLoading ? (
        <MbjLoading />
      ) : queryCompetencesEmployee.isError ? (
        <p>Erreur ...</p>
      ) : queryCompetencesEmployee.data.length === 0 ? (
        <div className={"noCompetences"}>
          <MbjNoResult text={"Aucune compétences pour le moment"} />
          {props.callToAction && (
            <>
              <div>Vous pouvez en ajouter manuellement sur cette page ou étoffer son CV :</div>
              <MbjButton size={"xs"} onClick={() => navigate("./../cv")}>
                Étoffer son CV
              </MbjButton>
            </>
          )}
        </div>
      ) : (
        <>
          <MbjSearchBar
            id={"sarchComp"}
            placeholder={"Rechercher une compétence"}
            className={"SearchBar"}
            onChange={(event) => setSearch(event.target.value)}
          />
          <MbjScrollArea>
            <MbjAccordion type="multiple" defaultValue={[]} className={"accordéon"}>
              {CompFiltered.map((CE, idx) => (
                <MbjAccordionItem value={`item-${idx}`} key={idx}>
                  <MbjEmployeeLineCompetence
                    key={idx}
                    CompetencesEmployee={CE}
                    isEditable={props.isEditable}
                    idEmployee={props.employeeId || -1}
                    isLoading={queryCompetencesEmployee.isLoading}
                    isError={queryCompetencesEmployee.isError}
                    EmployeeActivites={CE.EmployeeActivites}
                    themeColor={props.themeColor}
                  />
                </MbjAccordionItem>
              ))}
            </MbjAccordion>
          </MbjScrollArea>
        </>
      )}
    </MbjFlex>
  );
};
export const MbjEmployeeActiviteAccordion = styled(MbjEmployeeActiviteAccordionCtrl)((props) => ({
  ".noCompetences": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
    padding: "10px",
  },
}));
MbjEmployeeActiviteAccordion.defaultProps = {
  themeColor: "grey",
  callToAction: true,
  isEditable: true,
};
